import { MergedFeaturePoint } from './merged-feature-point.model';

type Dimensions = import('./maritime-ais-api').Dimensions;

export enum VesselSource {
  AIS = 'AIS',
  RISK_INTELLIGENCE = 'RISK_INTELLIGENCE',
}

export interface Vessel extends Partial<MergedFeaturePoint> {
  vessel_id: string;
  name: string;
  imo?: number | string;
  mmsi?: number | string;
  heading?: number;
  latitude: number;
  longitude: number;
  callsign: string;
  shiptype?: string;
  /** ISO 3166-1 alpha-2 flag code, as reported by the vessel via AIS. */
  flag?: string;
  // TODO: these should be numbers, but Alerts API returns string and History API returns number...
  course: number;
  speed?: number;
  dimensions?: Dimensions;
  source: VesselSource;
  timestamp?: string | number;
  /** Destination port as reported by the vessel via AIS. */
  destination?: string;
  /** Estimated time of arrival as reported by the vessel via AIS (Unix seconds). */
  eta?: number;
  /** Current draught in metres as reported by the vessel via AIS. */
  draught?: number;
}

export interface VesselFormItem {
  vessel_name: string;
  vessel_type: string;
  mmsi: string;
  imo: string;
}

export interface VesselV2FormItem {
  mmsi: string;
  imo: string;
}
